import React from 'react';

interface LeadProfileProps {
  leadResponse: {
    lead_company?: string | null;
    lead_title?: string | null;
    lead_location?: string | null;
    lead_email?: string | null;
    lead_phone?: string | null;
    lead_website?: string | null;
    lead_industry?: string | null;
    lead_linkedin_url?: string | null;
    alias_profile?: string | null;
  };
  aliasLinkedinUrl?: string;
}

const LeadProfile: React.FC<LeadProfileProps> = ({ leadResponse, aliasLinkedinUrl }) => {
  const profileFields = [
    { label: 'Company', value: leadResponse.lead_company },
    { label: 'Title', value: leadResponse.lead_title },
    { label: 'Location', value: leadResponse.lead_location },
    { label: 'Email', value: leadResponse.lead_email },
    { label: 'Phone', value: leadResponse.lead_phone },
    { label: 'Website', value: leadResponse.lead_website, isWebsite: true },
    { label: 'Industry', value: leadResponse.lead_industry },
    { label: 'Outreach Alias', value: leadResponse.alias_profile },
  ];

  // Filter out empty fields
  const populatedFields = profileFields.filter(field => field.value);

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
      <h3 className="font-medium text-gray-900 mb-3 flex items-center">
        <span className="mr-2">👤</span> Lead Profile
      </h3>
      <div className="space-y-2 text-sm">
        {populatedFields.map((field, index) => (
          <div key={index} className="flex justify-between">
            <span className="text-gray-600">{field.label}:</span>
            {field.isWebsite ? (
              <a 
                href={field.value?.startsWith('http') ? field.value : `https://${field.value}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:underline"
              >
                {field.value}
              </a>
            ) : (
              <span className="font-medium">{field.value}</span>
            )}
          </div>
        ))}
        {leadResponse.lead_linkedin_url && (
          <div className="mt-3">
            <a
              href={leadResponse.lead_linkedin_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
            >
              View LinkedIn Profile →
            </a>
          </div>
        )}
        {aliasLinkedinUrl && (
          <div className="mt-2">
            <a
              href={aliasLinkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-3 py-1 bg-indigo-600 text-white text-sm rounded hover:bg-indigo-700"
            >
              View Alias LinkedIn ({leadResponse.alias_profile}) →
            </a>
          </div>
        )}
        {populatedFields.length === 0 && !leadResponse.lead_linkedin_url && (
          <p className="text-gray-500 italic">No profile information available</p>
        )}
      </div>
    </div>
  );
};

export default LeadProfile;